module.exports = __webpack_public_path__ + "img/Slice1.8bd34748.png";